import { Component } from '@angular/core';
import { BaseApiService } from '../../Services/base-api.service';
import { AuthService } from '../../Services/auth.service';
import { ConfirmationService } from 'primeng/api';
import { BaseComponent } from '../../Base/base/base.component';

@Component({
  selector: 'app-delete-my-account',
  standalone: false,
  templateUrl: './delete-my-account.component.html',
  styleUrl: './delete-my-account.component.css'
})
export class DeleteMyAccountComponent extends BaseComponent {
userRole:string=''
constructor
    (
      private api: BaseApiService,
      private auth:AuthService,
      private confirmationService: ConfirmationService,

    ) {
     super();
     this.userRole=this.auth.getRoles().toString();
  }




  confirm1(event: Event) {
    this.confirmationService.confirm({
        target: event.target as EventTarget,
        message: 'Êtes-vous sûr de vouloir supprimer votre compte ?',
        header: 'Confirmation',
        closable: true,
        closeOnEscape: true,
        icon: 'pi pi-exclamation-triangle',
        rejectButtonProps: {
            label: 'Annuler',
            severity: 'secondary',
            outlined: true,
        },
        acceptButtonProps: {
            label: 'Supprimer mon compte',
            severity: 'danger',
        },
        accept: () => {
            this.api.DeletMyAccount()
        },
        reject: () => {
            
        },
    });
}



}
